import { render, staticRenderFns } from "./company_view.vue?vue&type=template&id=27077b97&scoped=true&"
import script from "./company_view.vue?vue&type=script&lang=js&"
export * from "./company_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27077b97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('27077b97', component.options)
    } else {
      api.reload('27077b97', component.options)
    }
    module.hot.accept("./company_view.vue?vue&type=template&id=27077b97&scoped=true&", function () {
      api.rerender('27077b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/company/company_view.vue"
export default component.exports